var debug = true;

function setCookie(name, value, exdate) {
    //If exdate exists then pass it as a new Date and convert to UTC format
    (exdate) && (exdate = new Date(exdate).toUTCString());
    var c_value = value + ((exdate === null || exdate === undefined) ? "" : "; expires=" + exdate);
    document.cookie = name + "=" + c_value;
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

var setInnerHTML = function(elm, html) {
    elm.innerHTML = html;
    Array.from(elm.querySelectorAll("script")).forEach((oldScript) => {
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes).forEach((attr) =>
            newScript.setAttribute(attr.name, attr.value)
        );
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
    });
};

// adding body classes where needed
document.addEventListener("DOMContentLoaded", () => {
    if (window.navigator.userAgent.includes("iPhone")) {
        let headerElement = document.getElementById("shopify-section-header");
        headerElement.classList.add("mobile");
        document.body.classList.add("mobile--iphone");
    }

    if (window.navigator.userAgent.includes("Android")) {
        document.body.classList.add("mobile--android");
    }

    if (window.navigator.userAgent.includes("Chrome")) {
        document.body.classList.add("browser--chrome");
    }

});

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute(
        "aria-expanded",
        summary.parentNode.hasAttribute("open")
    );

    if (summary.nextElementSibling.getAttribute("id")) {
        summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
        event.currentTarget.setAttribute(
            "aria-expanded",
            !event.currentTarget.closest("details").hasAttribute("open")
        );
    });

    if (summary.closest("header-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = [
        "ARROWUP",
        "ARROWDOWN",
        "ARROWLEFT",
        "ARROWRIGHT",
        "TAB",
        "ENTER",
        "SPACE",
        "ESCAPE",
        "HOME",
        "END",
        "PAGEUP",
        "PAGEDOWN",
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener("keydown", (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener("mousedown", (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        "focus",
        () => {
            if (currentFocusedElement)
                currentFocusedElement.classList.remove("focused");

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add("focused");
        },
        true
    );
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
            '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
            "*"
        );
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => {
        if (!video.hasAttribute('muted')) {
            video.pause()
        }
    });
    document.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus"
            ? this.input.stepUp()
            : this.input.stepDown();
        if (previousValue !== this.input.value)
            this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(
    country_domid,
    province_domid,
    options
) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(
        options["hideElement"] || province_domid
    );

    Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
    );

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        setTimeout(() => {
            const modalClose = this.querySelector('[id^="ModalClose-"]')
            modalClose.addEventListener(
                "click",
                this.hide.bind(this, false)
            );
            this.addEventListener("keyup", (event) => {
                if (
                    typeof event.code !== "undefined" &&
                    event.code.toUpperCase() === "ESCAPE"
                )
                    this.hide();
            });
            if (this.classList.contains("media-modal")) {
                this.addEventListener("pointerup", (event) => {
                    if (
                        event.pointerType === "mouse" &&
                        !event.target.closest("deferred-media, product-model")
                    )
                        this.hide();
                });
            } else {
                this.addEventListener("click", (event) => {
                    if (event.target === this) this.hide();
                });
            }
        })
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden");
        this.setAttribute("open", "");
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove("overflow-hidden");
        document.body.dispatchEvent(new CustomEvent("modalClosed"));
        this.removeAttribute("open");
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        setTimeout(() => {
            const button = this.querySelector("button");

            if (!button) return;
            button.addEventListener("click", () => {
                const modal = document.querySelector(
                    this.getAttribute("data-modal")
                );

                if (modal) modal.show(button);
            });
        })
    }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener("click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute("loaded")) {
            const content = document.createElement("div");
            content.appendChild(
                this.querySelector(
                    "template"
                ).content.firstElementChild.cloneNode(true)
            );

            this.setAttribute("loaded", true);
            const deferredElement = this.appendChild(
                content.querySelector("video, model-viewer, iframe")
            );
            if (focus) deferredElement.focus();
        }
    }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector(
            ".slider-counter--current"
        );
        this.pageTotalElement = this.querySelector(".slider-counter--total");
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) =>
            this.initPages()
        );
        resizeObserver.observe(this.slider);

        this.slider.addEventListener("scroll", this.update.bind(this));
        this.prevButton.addEventListener(
            "click",
            this.onButtonClick.bind(this)
        );
        this.nextButton.addEventListener(
            "click",
            this.onButtonClick.bind(this)
        );
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(
            (element) => element.clientWidth > 0
        );
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset =
            this.sliderItemsToShow[1].offsetLeft -
            this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
            this.sliderItemOffset
        );
        this.totalPages =
            this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        const previousPage = this.currentPage;
        this.currentPage =
            Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(
                new CustomEvent("slideChanged", {
                    detail: {
                        currentPage: this.currentPage,
                        currentElement:
                            this.sliderItemsToShow[this.currentPage - 1],
                    },
                })
            );
        }

        if (this.enableSliderLooping) return;

        if (
            this.isSlideVisible(this.sliderItemsToShow[0]) &&
            this.slider.scrollLeft === 0
        ) {
            this.prevButton.setAttribute("disabled", "disabled");
        } else {
            this.prevButton.removeAttribute("disabled");
        }

        if (
            this.isSlideVisible(
                this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
            )
        ) {
            this.nextButton.setAttribute("disabled", "disabled");
        } else {
            this.nextButton.removeAttribute("disabled");
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide =
            this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (
            element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
            element.offsetLeft >= this.slider.scrollLeft
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
            event.currentTarget.name === "next"
                ? this.slider.scrollLeft + step * this.sliderItemOffset
                : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.slider.scrollTo({
            left: this.slideScrollPosition,
        });
    }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector(".slider-buttons");
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode =
            this.slider.querySelector(".slideshow__slide");
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(
            this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
        );
        this.sliderControlLinksArray.forEach((link) =>
            link.addEventListener("click", this.linkToSlide.bind(this))
        );
        this.slider.addEventListener(
            "scroll",
            this.setSlideVisibility.bind(this)
        );
        this.setSlideVisibility();

        if (this.slider.getAttribute("data-autoplay") === "true")
            this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener(
            "click",
            this.autoPlayToggle.bind(this)
        );
        this.addEventListener("mouseover", this.focusInHandling.bind(this));
        this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
        this.addEventListener("focusin", this.focusInHandling.bind(this));
        this.addEventListener("focusout", this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) return;

        if (isFirstSlide && event.currentTarget.name === "previous") {
            this.slideScrollPosition =
                this.slider.scrollLeft +
                this.sliderFirstItemNode.clientWidth *
                this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === "next") {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition,
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll(
            ".slider-counter__link"
        );
        this.prevButton.removeAttribute("disabled");

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
            link.classList.remove("slider-counter__link--active");
            link.removeAttribute("aria-current");
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add(
            "slider-counter__link--active"
        );
        this.sliderControlButtons[this.currentPage - 1].setAttribute(
            "aria-current",
            true
        );
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton =
            event.target === this.sliderAutoplayButton ||
            this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton =
            event.target === this.sliderAutoplayButton ||
            this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute("aria-live", "off");
        clearInterval(this.autoplay);
        this.autoplay = setInterval(
            this.autoRotateSlides.bind(this),
            this.autoplaySpeed
        );
    }

    pause() {
        this.slider.setAttribute("aria-live", "polite");
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add(
                "slideshow__autoplay--paused"
            );
            this.sliderAutoplayButton.setAttribute(
                "aria-label",
                window.accessibilityStrings.playSlideshow
            );
        } else {
            this.sliderAutoplayButton.classList.remove(
                "slideshow__autoplay--paused"
            );
            this.sliderAutoplayButton.setAttribute(
                "aria-label",
                window.accessibilityStrings.pauseSlideshow
            );
        }
    }

    autoRotateSlides() {
        const slideScrollPosition =
            this.currentPage === this.sliderItems.length
                ? 0
                : this.slider.scrollLeft +
                this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const button = item.querySelector("a");
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute("tabindex");
                item.setAttribute("aria-hidden", "false");
                item.removeAttribute("tabindex");
            } else {
                if (button) button.setAttribute("tabindex", "-1");
                item.setAttribute("aria-hidden", "true");
                item.setAttribute("tabindex", "-1");
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
            (this.sliderControlLinksArray.indexOf(event.currentTarget) +
                1 -
                this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();

        this.setupEventListeners();
        this.setupElements();
        this.variantData = this.getVariantData();
        this.lastSelectedElementId = null;
    }

    setupEventListeners() {
        this.addEventListener("change", this.onVariantChange);
    }

    setupElements() {
        this.mediaGallery = document.getElementById(
            `MediaGallery-${this.dataset.section}`
        );
        this.mediaModalContent = document.querySelector(
            `#ProductModal-${this.dataset.section} .product-media-modal__content`
        );
        this.productForm = document.getElementById(
            `product-form-${this.dataset.section}`
        );

        this.addToCartButton = this.productForm.querySelector("#addToCart");

        this.productLoadingSpinner = this.addToCartButton.querySelector(
            ".loading-overlay__spinner"
        );
        this.addToCartButtonText = this.addToCartButton.querySelector("span");
        this.price = document.getElementById(`price-${this.dataset.section}`);
        this.priceMobile = document.getElementById(
            `price-${this.dataset.section}-mobile`
        );
        this.variantPicker = document.querySelector("variant-radios");
        this.productFormButtons = this.productForm.querySelector(
            ".product-form__buttons"
        );
    }

    async onVariantChange(e) {
        this.lastSelectedElementId = e.target.id;
        this.options = this.getOptionsFromSelects();
        this.currentVariant = this.getCurrentVariant();

        this.productLoadingSpinner.classList.remove("hidden");
        this.toggleAddToCartButton(true);

        if (!this.currentVariant) {
            this.setUnavailable(true);
            this.productLoadingSpinner.classList.add("hidden");
            return;
        }

        this.updateMediaAndModal();

        const urlParams = new URLSearchParams(window.location.search);
        const hasRecipeID = urlParams.has('recipeId');

        if (!hasRecipeID) {
            this.updateURL();
        }
        
        this.updateVariantIdInput();
        this.updateButton();

        let variantHTML = await this.getVariantHTML()

        this.renderDisplayFromHTML(variantHTML);

        this.focusLastSelectedElement();

        document.dispatchEvent(
            new CustomEvent("variant_changed", {
                detail: this.currentVariant,
            })
        );
    }

    updateButton() {
        
        let params = new URLSearchParams(document.location.search);
        let urlVariant = params.get("variant"); 

        //variables to update
        var buttonDiv = document.getElementById("init-customizer");
        var orContainer = document.getElementsByClassName('or-container');
        var atcDiv = document.getElementById("addToCart");

        if(urlVariant && productData) {

            const matchedItem = productData[urlVariant];

            //hides customize if not customizable, shows only ATC
            if(matchedItem && matchedItem.isCustomizable !== null) {
                var isCustomizable = matchedItem.isCustomizable;

                //if can customize
                if(isCustomizable && buttonDiv) {
                    buttonDiv.classList.remove("hide");
                    orContainer[0].classList.remove("hide");
                }

                //if no can
                if(!isCustomizable && buttonDiv) {
                    buttonDiv.classList.add("hide");
                    orContainer[0].classList.add("hide");
                }
                
            }
           
        } else {
            return;
        }

    }

    focusLastSelectedElement() {
        if (this.lastSelectedElementId != null) {
            this.elementToFocus = document.getElementById(
                this.lastSelectedElementId
            );
            if (!this.elementToFocus) return;

            this.elementToFocus.focus();
        }
    }

    getOptionsFromSelects() {
        return Array.from(
            this.querySelectorAll("select"),
            (select) => select.value
        );
    }

    getCurrentVariant() {
        return this.variantData.find((variant) => {
            let optionsMatch = true;

            for (const index in variant.options) {
                if (this.options[index] !== variant.options[index]) {
                    optionsMatch = false;
                }
            }

            return optionsMatch;
        });
    }

    updateMediaAndModal() {
        if (
            !this.currentVariant.featured_media ||
            !this.mediaModalContent ||
            !this.mediaGallery
        )
            return;

        this.mediaGallery.setActiveMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            true,
            this.currentVariant
        );

        const currentVariantMedia = this.mediaModalContent.querySelector(
            `[data-media-id$="${this.currentVariant.featured_media.id}"]`
        );

        this.mediaModalContent.prepend(currentVariantMedia);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;

        window.history.replaceState(
            {},
            "",
            `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateVariantIdInput() {
        const input = this.productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    async getVariantHTML() {
        const response = await fetch(`
            ${this.dataset.url}
            ?variant=${this.currentVariant.id}
            &section_id=${this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }
        `);

        return response.text();
    }

    async renderDisplayFromHTML(responseHTML) {
        const htmlFromRequest = new DOMParser().parseFromString(
            responseHTML,
            "text/html"
        );

        let unavailable = !this.currentVariant.available;

        this.addToCartButton.innerHTML =
            htmlFromRequest.getElementById("addToCart").innerHTML;

        this.updateDesktopPriceFromReturnHTML(htmlFromRequest);
        this.updateMobilePriceFromReturnHTML(htmlFromRequest);
        this.updateVariantPickerFromReturnHTML(htmlFromRequest);

        this.toggleProductButtons(unavailable);
        this.toggleAddToCartButton(unavailable);
        this.setUnavailable(unavailable);

        this.updateProductLoadingSpinner();
        this.updateMobileColorLabel();

        this.setAddToCartButtonText(
            unavailable
                ? window.variantStrings.addToCart
                : window.variantStrings.soldOut
        );

        document.dispatchEvent(new Event("variant_change"));
    }

    updateProductLoadingSpinner() {
        this.productLoadingSpinner = this.addToCartButton.querySelector(
            ".loading-overlay__spinner"
        );
        this.productLoadingSpinner.classList.add("hidden");
    }

    updateMobileColorLabel() {
        const outputValue = document.querySelector(".option-container__value");
        const colorElement = document.querySelector(
            'input[type="radio"][name="color"]:checked'
        );

        if (!outputValue || !colorElement) return;

        outputValue.innerHTML += colorElement.value;
    }

    updateDesktopPriceFromReturnHTML(htmlFromRequest) {
        const priceSource = htmlFromRequest.getElementById(
            `price-${this.dataset.section}`
        );

        if (!priceSource || !this.price) return;

        this.price.innerHTML = priceSource.innerHTML;
        this.price.classList.remove("visibility-hidden");
    }

    updateMobilePriceFromReturnHTML(htmlFromRequest) {
        const priceSourceMobile = htmlFromRequest.getElementById(
            `price-${this.dataset.section}-mobile`
        );

        if (!priceSourceMobile || !this.priceMobile) return;

        this.priceMobile.innerHTML = priceSourceMobile.innerHTML;
        this.priceMobile.classList.remove("visibility-hidden");
    }

    updateVariantPickerFromReturnHTML(htmlFromRequest) {
        const variantPickerSource =
            htmlFromRequest.querySelector("variant-radios");

        if (!variantPickerSource || !this.variantPicker) return;

        this.variantPicker.innerHTML = variantPickerSource.innerHTML;
    }

    setUnavailable(unavailable) {
        this.price.classList.toggle("visibility-hidden", unavailable);
    }

    toggleProductButtons(hide) {
        this.productFormButtons.classList.toggle("hidden", hide);
    }

    toggleAddToCartButton(disable) {
        this.addToCartButton.setAttribute("disabled", "disabled");
        if (disable) return;

        this.addToCartButton.removeAttribute("disabled");
    }

    setAddToCartButtonText(text) {
        this.addToCartButtonText.textContent = text;
    }

    getVariantData() {
        let variantsData = JSON.parse(
            this.querySelector("#product-variant-data").textContent
        );

        const dimensionsData = JSON.parse(
            this.querySelector("#product-variant-dimensions").textContent
        )

        for (const key in variantsData) {
            if (dimensionsData.hasOwnProperty(variantsData[key].id)) {
                variantsData[key].dimensions = dimensionsData[variantsData[key].id];
            }
        }

        return variantsData;
    }
}
customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();

        this.options = this.getOptionsFromSelects();
        document.addEventListener("DOMContentLoaded", () => {
            this.dispatchEvent(new Event("change"));
        });
    }

    getOptionsFromSelects() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        return fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll("input")).find(
                (radio) => radio.checked
            ).value;
        });
    }
}
customElements.define("variant-radios", VariantRadios);

class GiftMessage extends HTMLElement {
    constructor() {
        super();

        this.addEventListener(
            "change",
            debounce((event) => {
                const body = JSON.stringify({
                    attributes: { "gift-message": event.target.value.trim() },
                });
                fetch(`${routes.cart_update_url}`, {
                    ...fetchConfig(),
                    ...{ body },
                });
            }, 300)
        );
    }
}
customElements.define("gift-message", GiftMessage);

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();

        const removeItem = (event) => {

            event.preventDefault();

            if(this.dataset && this.dataset.recipe) {
                let recipe = this.dataset.recipe;         

                let allSubItems = document.querySelectorAll("[data-productkey]");
                let listToRemove = [];

                allSubItems.forEach( (individualItem) => {

                    var subItemProductKey = individualItem.dataset.productkey;

                    if(individualItem.dataset.recipe === recipe) {
                        listToRemove.push(subItemProductKey);
                    }

                })

                var deleteURL = spectrumBuildDelete(listToRemove);

                window.location = deleteURL;
            } else {
                var deleteIndividual = spectrumBuildDelete([this.dataset.productkey]);
                window.location = deleteIndividual;
            }

        }

        this.addEventListener("click", (event) => {
            removeItem(event)
        });

        this.addEventListener("keyup", (event) => {
            if (event.key == "Enter") {
                removeItem(event)
            }
        });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);

document.addEventListener("DOMContentLoaded", () => {
    let pfTextItems = document.querySelectorAll('[data-pf-type="Text"]');
    if (pfTextItems) {
        for (item of pfTextItems) {
            item.setAttribute("tabindex", 0);
        }
    }
});

class ProductModal extends ModalDialog {
    constructor() {
        super();
    }
    hide() {
        super.hide();
    }
    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }
    showActiveMedia() {
        this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
                'data-media-id'
            )}"])`
        ).forEach((element) => {
            if (this.dataset.hasOnlyDefaultVariant == "0") {
                element.classList.remove('active');
            } else {
                element.classList.add('active');
            }
        });

        const activeMedia = this.querySelector(
            `[data-media-id="${this.openedBy.getAttribute(
                'data-media-id'
            )}"]`
        );

        try {
            const activeMediaTemplate =
                activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate
                ? activeMediaTemplate.content
                : null;
        } catch (e) { }

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft =
            (activeMedia.width - container.clientWidth) / 2;

        if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
        )
            activeMedia.loadContent();
    }
}
customElements.define('product-modal', ProductModal);

function getUTMParameters() {
    // First try to get from current URL
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');

    // If not in URL, check localStorage
    if (!utmSource) {
        return JSON.parse(getCookie('utm_params') || '{}');
    }

    // If in URL, store and return them
    const params = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
        const value = urlParams.get(param);
        if (value) params[param] = value;
    });

    const tomorrow = new Date(Date.now() + 86400000)

    setCookie('utm_params', JSON.stringify(params), tomorrow);
}

const utmParams = getUTMParameters()

document.addEventListener("DOMContentLoaded", () => {
    const utmFallbackLinks = document.querySelectorAll('.utm-fallback-link')
    const paramsFound = (typeof utmParams == 'object') ? !!Object.keys(utmParams).length : false

    for (const utmFallbackLink of utmFallbackLinks) {
        const baseLink = utmFallbackLink.getAttribute('href')
        const separator = baseLink.includes('?') ? "&" : "?"
        const fallbackPayload = utmFallbackLink.dataset.fallbackUtmPayload

        if (paramsFound) {
            let newLink = baseLink + separator
            for (const param of Object.keys(utmParams)) {
                newLink += `${param}=${utmParams[param]}&`
            }
            newLink = newLink.replace(/\&$/, "")

            utmFallbackLink.setAttribute('href', newLink)
        } else if (typeof fallbackPayload != "undefined") {
            const newLink = `${baseLink}${separator}${fallbackPayload}`

            utmFallbackLink.setAttribute('href', newLink)
        }
    }
})


document.addEventListener("DOMContentLoaded", () => {
    const cookieOpener = document.getElementById('cookie-opener')

    if (cookieOpener) {
        cookieOpener.addEventListener('click', () => {
            const cookieButton = document.querySelector('.osano-cm-window__widget')
            if (!cookieButton) {
                return false
            }

            cookieButton.click()
        })
    }
})

/* Spectrum Customizer */
function spectrumBuildDelete(keys) {
  let parts = keys.map(key => `updates[${key}]=0`);
  return `/cart/update?${parts.join("&")}`;
}

function spectrumBuildUpdate(items, quantity, increaseTheseOnce) {
  
    let parts = items.map(item => {
    let q = quantity;

    // when match, do only single quantity update
    if (increaseTheseOnce.includes(item.title)) {q = 1;}

    return `updates[${item.key}]=${q}`;
  });

  return `/cart/update?${parts.join("&")}`;
}

class CustomTooltip extends HTMLElement {
  constructor() {
    super();
    this.trigger = null;
    this.tooltip = null;
    this.closeButton = null;
  }

  connectedCallback() {

    this.trigger = this.querySelector(".tooltip-trigger");
    this.tooltip = this.querySelector(".tooltip");
    this.closeButton = this.querySelector(".close-button");

    if (!this.trigger || !this.tooltip || !this.closeButton) return;

    this.trigger.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.tooltip.classList.toggle("show");
        this.tooltip.classList.remove("hide");
    });

    this.closeButton.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.tooltip.classList.toggle("hide");
        this.tooltip.classList.remove("show");
    })

    document.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.tooltip.classList.remove("show");
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.tooltip.classList.contains("show")) {
        this.tooltip.classList.remove("show");
      }
    });
  }
}
customElements.define("custom-tooltip", CustomTooltip);